import { render, staticRenderFns } from "./IconFamily.vue?vue&type=template&id=0a8085e8&"
import script from "./IconFamily.vue?vue&type=script&lang=js&"
export * from "./IconFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports